import React from "react";
import { Link } from "react-router-dom";
import { CATEGORY_ICON, TIER_COLORS, TIER_LABEL } from "../data/brand";
import { resolvePhotoUrl } from "../lib/photos";

export default function ListingCard({ listing }) {
  const icon = CATEGORY_ICON[listing.category_slug] || "fa-briefcase";
  const cover = resolvePhotoUrl(listing.photos?.[0]);
  return (
    <Link to={`/annunci/${listing.id}`} className="hm-card block overflow-hidden group" data-testid={`listing-card-${listing.id}`}>
      <div className="aspect-[16/10] relative bg-[#0F0F10] overflow-hidden">
        {cover ? (
          <img src={cover} alt={listing.title} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <i className={`fas ${icon} text-5xl text-zinc-700 group-hover:text-[#FFBE00] transition-colors`}></i>
          </div>
        )}
        {listing.featured && (
          <div className="absolute top-2 left-2 md:top-3 md:left-3 px-1.5 md:px-2 py-0.5 md:py-1 bg-[#FFBE00] text-black text-[8px] md:text-[10px] font-bold uppercase tracking-wider rounded">
            Consigliato
          </div>
        )}
        {listing.tier && (
          <div className="absolute top-2 right-2 md:top-3 md:right-3 px-1.5 md:px-2 py-0.5 md:py-1 bg-black/80 border border-zinc-800 text-[8px] md:text-[10px] font-bold uppercase tracking-wider rounded" style={{ color: TIER_COLORS[listing.tier] }}>
            {TIER_LABEL[listing.tier]}
          </div>
        )}
      </div>
      <div className="p-3 md:p-5">
        <div className="flex items-center gap-1.5 md:gap-2 mb-1.5 md:mb-2">
          <i className={`fas ${icon} text-[#FFBE00] text-[10px] md:text-xs`}></i>
          <span className="text-[9px] md:text-[11px] uppercase tracking-widest text-zinc-500 font-semibold truncate">{listing.category_name}</span>
        </div>
        <h3 className="font-heading font-bold text-sm md:text-lg leading-tight text-white group-hover:text-[#FFBE00] transition-colors line-clamp-2">{listing.title}</h3>
        <p className="mt-1.5 md:mt-2 text-xs md:text-sm text-zinc-400 line-clamp-2 leading-relaxed">{listing.description || "Scopri di più su questo professionista."}</p>
        <div className="mt-1.5 md:mt-2 text-[10px] md:text-xs font-bold uppercase tracking-wider text-[#FFBE00] group-hover:text-[#E619A8] transition-colors">
          Clicca per leggere tutto <span className="inline-block transition-transform group-hover:translate-x-0.5">→</span>
        </div>
        <div className="mt-2 md:mt-4 flex items-center justify-between text-[10px] md:text-xs text-zinc-500 gap-2 pt-2 md:pt-3 border-t border-zinc-900">
          <span className="truncate">{listing.city ? <><i className="fas fa-map-marker-alt mr-1"></i>{listing.city}</> : <>&nbsp;</>}</span>
          <span className="text-zinc-600 truncate hidden md:inline">{listing.author_name}</span>
        </div>
      </div>
    </Link>
  );
}
